import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const JoinList = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("VALID EMAIL REQUIRED");
      return;
    }
    setLoading(true);
    try {
      await api.post("/signup", { email });
      setDone(true);
      toast.success("YOU'RE ON THE LIST");
    } catch (err) {
      toast.error("SOMETHING BROKE. TRY AGAIN.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="join"
      data-testid="join-list"
      className="relative mx-auto w-full max-w-[1400px] px-6 pt-10 pb-12 md:px-10 md:pt-16 md:pb-32"
    >
      <div className="grid grid-cols-12 gap-10">
        <div className="col-span-12 md:col-span-6">
          <span className="font-mono-stamp text-xs text-[#a0a0a0]">
            § 04 · JOIN THE LIST
          </span>
          <h2 className="font-display mt-6 text-5xl leading-[0.88] md:text-7xl">
            BE FIRST
            <br />
            <span className="text-outline">IN LINE.</span>
          </h2>
          <p className="mt-6 max-w-md font-mono-stamp text-xs leading-relaxed text-[#a0a0a0]">
            DROPS GO LIVE WITHOUT WARNING. LIST MEMBERS GET A 24-HOUR HEAD
            START, RUN-TAG PREVIEWS, AND FIRST ACCESS TO RETURNS.
          </p>
        </div>

        <div className="col-span-12 md:col-span-6 md:pl-10">
          {done ? (
            <div
              data-testid="join-success"
              className="border border-white bg-[#0a0a0a] p-8"
            >
              <p className="font-mono-stamp text-xs text-[#a0a0a0]">▸ CONFIRMED</p>
              <p className="font-display mt-3 text-4xl md:text-5xl">
                YOU'RE ON.
              </p>
              <p className="mt-4 font-mono-stamp text-xs text-[#a0a0a0]">
                NEXT DROP LANDS IN YOUR INBOX BEFORE IT HITS THE SITE.
              </p>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="border border-[#333] bg-[#0a0a0a] p-6"
            >
              <label className="font-mono-stamp text-[10px] text-[#a0a0a0]">
                ▸ EMAIL
              </label>
              <input
                data-testid="join-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="YOU@EMAIL.COM"
                className="mt-2 w-full border-b-2 border-[#444] bg-transparent py-3 font-mono-stamp text-base text-white placeholder:text-[#555] focus:border-white focus:outline-none"
              />
              <div className="mt-6 flex justify-center md:block">
                <button
                  type="submit"
                  data-testid="join-submit"
                  disabled={loading}
                  className="btn-brutal btn-brutal-solid md:w-full md:justify-center disabled:opacity-50"
                >
                  {loading ? "SENDING…" : "JOIN THE LIST →"}
                </button>
              </div>
              <p className="mt-4 font-mono-stamp text-[10px] text-[#555]">
                NO SPAM. DROPS ONLY. UNSUBSCRIBE ANY TIME.
              </p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
